import { useState, useEffect } from "react";

const MESSAGES = [
  "Digitizing Text...",
  "Resizing Files...",
  "Generating Embroidery...",
];

export function LoadingMessage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // Fade out
      setFade(false);

      // Wait for fade out, then change text and fade in
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % MESSAGES.length);
        setFade(true);
      }, 500); // Half second for fade out
    }, 2500); // Change message every 2.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="empty-preview">
      <p
        aria-busy="true"
        style={{
          opacity: fade ? 1 : 0,
          transition: 'opacity 0.5s ease-in-out',
          marginBottom: 0,
        }}
      >
        {MESSAGES[currentIndex]}
      </p>
    </div>
  );
}
